module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.notifications.length) ? _c('div', {
    staticClass: "notifications"
  }, _vm._l((_vm.notifications), function(item, index) {
    return _c('Card', _vm._b({
      key: index,
      on: {
        "notificationViewed": _vm.postData
      }
    }, 'Card', item, false))
  }), 1) : _c('Warning', [_c('p', [_vm._v("Уведомлений нет.")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ee45d7c","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/notification/views/notifications/NotificationsNotifications.vue
// module id = 0ffd745798eb47141349
// module chunks = 84